const style = {
  select: {
    padding: `5px 15px`,
    width: `90px`,
    height: `30px`,
    overflow: `hidden`,
    background: `#fff`,
    border: `1px solid #ddd`,
    borderRadius: 0,
    '-webkit-appearance': `none`,
    fontSize: `13px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/selector.js